import React from 'react';
import { Button, Divider } from 'antd';
import cn from 'classnames';
import { toolbarBlockNames as blockNames } from '../../config';
import ToolbarBlock from '../ToolbarBlock';
import styles from './index.module.scss';

const orders = {
  [blockNames.heading]: 1,
  [blockNames.inlineStyle]: 2,
  [blockNames.list]: 3,
  [blockNames.link]: 4,
  [blockNames.phoneLink]: 5,
};

const sortCb = (a, b) => orders[a] - orders[b];

const Toolbar = ({ toolList, className, onClose }) => {
  return (
    <div className={cn(styles.root, className)}>
      <div className={styles.tools}>
        {toolList.sort(sortCb).map((name, index) => (
          <Element
            key={name}
            name={name}
            hasDivider={index !== toolList.length - 1}
          />
        ))}
      </div>
      {typeof onClose === 'function' && (
        <Button
          icon="close"
          className={styles.closeBtn}
          onClick={onClose}
        />
      )}
    </div>
  );
};

export default Toolbar;

function Element({ name, hasDivider }) {
  return (
    <div className={styles.blockWrapper}>
      <ToolbarBlock name={name} />
      {hasDivider && (
        <Divider
          type="vertical"
          className={styles.divider}
        />
      )}
    </div>
  );
}
